<template>
  <div class="ui raised blue segment">
    <a class="ui red ribbon big label" v-if="question.mandatory">
      * {{ $t("mandatory") }}</a
    >
    <h1 class="ui center aligned header">{{ question.prompt }}</h1>
    <div class="ui center aligned header">
      <div
        class="ui icon labeled big button"
        v-bind:class="{
          basic: !is_answer_selected(answer, question),
          green: is_answer_selected(answer, question),
        }"
        :style="'background-color: ' + answer.color"
        v-for="(answer, aidx) in answers"
        :key="aidx"
        @click="set_answer(answer)"
      >
        <i :class="answer.icon + ' icon'"></i> {{ answer.prompt }}
      </div>
    </div>
    <div class="ui basic blue right ribbon label" v-if="question.max_answers">
      {{ question.max_answers }}
      <span v-if="question.max_answers == 1">{{ $t("answer accepted") }}</span>
      <span v-if="question.max_answers > 1">{{
        $t("maximum answers accepted")
      }}</span>
    </div>
    <!-- <pre>{{ question }}</pre> -->
  </div>
</template>

<script>
export default {
  name: "Question",
  computed: {
    answers() {
      let vm = this;
      let answ = vm.question.answers || [];
      answ = answ.sort((a, b) => {
        {
          if (Number(a.order || 0) > Number(b.order || 0)) return 1;
          else if (Number(a.order || 0) < Number(b.order || 0)) return -1;
          else return 0;
        }
      });
      // .map((an) => {
      //   an.is_selected = vm.responses.find((r) => {
      //     return (
      //       r.question.order == vm.question.prompt &&
      //       r.answer.prompt == an.prompt
      //     );
      //   });
      //   return an;
      // });
      return answ;
    },
  },
  data() {
    return {};
  },
  methods: {
    set_answer(answer) {
      this.$emit("set_answer", this.question, answer);
      //   console.log(answer);
      //   answer.is_selected = !answer.is_selected;
    },
    is_answer_selected(answer, question) {
      let vm = this;
      // console.log("answer", answer);
      // console.log("question", question);
      let exists = vm.responses.find((rr) => {
        return (
          rr.question.uuid == question.uuid && rr.answer.uuid == answer.uuid
        );
      });
      if (exists) return true;
      else return false;
    },
  },
  props: { question: Object, responses: Array },
};
</script>
